// GENERATED FROM THE DOCX -- DO NOT HAND-EDIT.
//
// Emitted directly from word/document.xml of
// HG_Fitter_CoMarketing_Guide_and_Kit_2026-09.docx by the generator recorded in the commit
// message. It is generated rather than retyped for one reason: a first pass at this file was
// typed by hand and silently "corrected" the kit's straight apostrophes and quotes into curly
// ones. That is not verbatim, and the command says the copy blocks are the kit text verbatim.
// The docx uses U+0027 and U+0022 throughout; so does this file.
//
// To change any string here, change the docx and re-run the generator.
//
// TWO STRINGS DEPART FROM THE DOCX, ON RANDALL'S RULING (2026-10-02): a fitter does not read his name in the app.
// The kit says "Sent to Randall for review" (the checklist) and "send it to Randall before it goes live" (the rules
// in one breath); here both say Henry-Griffitts. THE DOCX ITSELF STILL NAMES HIM. If the generator is re-run before
// the docx is changed, these two come back in THIS file -- and no further: brandKit.js passes every string through
// fitterFacing() before the page sees it, so a regenerated file cannot show a fitter his name. The content check's
// app-wording row will still report the file, which is the prompt to re-apply the two lines here or fix the docx.
//
// AND TWO WORDS DEPART FROM THE DOCX FOR HOUSE SPELLING (feedback #28): "practise the compensation" in A1 and in the
// short social post is "practice" here, because the course uses US spelling throughout. The docx still says "practise".
// A re-run of the generator brings it back; re-apply the change here or fix the docx.

export const COPY_BLOCKS = [
  {
    id: `A1`,
    title: `A1. Hero block — for the top of your HG fitting page`,
    text: `H1: Henry-Griffitts Club Fitting in [City]
Sub-line: Clubs built to the swing you actually have — fitted by a Henry-Griffitts [Your Title], built in Coeur d'Alene, Idaho.
Button: Book Your Fitting`,
  },
  {
    id: `A2`,
    title: `A2. "Why a Henry-Griffitts fitting" — the main section (≈220 words)`,
    text: `Equipment affects motion.

A club that fits lets you make a balanced, athletic swing. A club that doesn't teaches you to compensate for it — and then you practice the compensation. That single idea is why Henry-Griffitts has built clubs one golfer at a time since 1983, and why the fitting matters more than the badge on the head.

It's dynamic, not static. You hit balls. Lie angle is read from real strikes on the lie board, not from your height and wrist-to-floor measurement, and the fit is refined as your balance improves during the session. Henry-Griffitts holds the patent on this lie-board method.

You're fitted by someone trained in a method. Henry-Griffitts has taught clubfitting to PGA and LPGA professionals for more than thirty years. [Your Name] is a Henry-Griffitts [Your Title] — fitted by a person who knows why each spec matters, not by a launch-monitor menu.

The club is built to you. Six shaft flexes, three deflection points, three head designs, and lie, loft and length each set to your swing. Every set is built at Henry-Griffitts in Coeur d'Alene, Idaho, and ships in five business days. Loft and lie on your Henry-Griffitts set are checked and adjusted at no charge for as long as you own it.

[Book Your Fitting] · Learn more about the clubs at henry-griffitts.com`,
  },
  {
    id: `A3`,
    title: `A3. "What happens in a fitting" — the process (≈180 words)`,
    text: `1. We watch you swing. Before anything is measured, you hit balls with your own clubs. Balance, contact and ball flight tell us where to start.
2. Lie angle, from the lie board. You hit off the lie board with tape on the sole. The mark shows whether the club is arriving toe-down or heel-down, and we demonstrate on the spot what that does to your starting direction.
3. Shaft, length and loft — tested, not assumed. Using the Henry-Griffitts fitting system, you hit the actual combinations: different flexes and deflection points, different lengths, different lofts. We're watching balance and ball flight, not just numbers.
4. Woods to match the irons. Driver and fairway shafts are chosen to work with what the irons showed us.
5. A final lie check. It's normal for the correct lie angle to change during a session as your balance improves, so we confirm it before writing the order.
6. Your specification. You leave with a fitting sheet, and Henry-Griffitts builds the set to it. Orders ship in five business days.`,
  },
  {
    id: `A4`,
    title: `A4. FAQ block`,
    text: `How long does a fitting take? Plan on [60–90] minutes. (Set your own time.)

Do I need to buy clubs? No. The fitting stands on its own and you'll leave knowing your specifications. Most golfers do order, because the difference is obvious on the range.

What does a Henry-Griffitts set cost? Henry-Griffitts publishes suggested retail prices at henry-griffitts.com; a typical iron set lands in the range you'd expect from a premium custom builder. Your quote comes from the fitting, because the shafts and heads that fit you determine it.

What if my clubs need adjusting later? Loft and lie on a Henry-Griffitts-built set are checked and adjusted at no charge for as long as you own them. I'll arrange it and Henry-Griffitts technicians do the work.

I've been fitted before. Why is this different? Most fittings are static — measurements and a launch monitor. This one reads lie angle from your actual strike and refines the fit as your swing settles. That's the patented Henry-Griffitts method, and it's why the results hold up on the course.

Who is Henry-Griffitts? A custom club fitting and manufacturing company founded in 1983 in Coeur d'Alene, Idaho, that has trained fitters and PGA professionals in its method for more than thirty years.`,
  },
  {
    id: `A5`,
    title: `A5. Short "about" line for your bio or footer`,
    text: `[Your Name] is a Henry-Griffitts [Your Title], fitting golfers in [City] with the patented Henry-Griffitts dynamic lie-board method. Clubs are built one golfer at a time in Coeur d'Alene, Idaho.`,
  },
  {
    id: `A6`,
    title: `A6. Meta descriptions (≤155 characters)`,
    text: `Henry-Griffitts club fitting in [City]. Dynamic lie-board fitting by a certified fitter; clubs built to your swing since 1983. Book your fitting.

Custom golf club fitting in [City] with the patented Henry-Griffitts method. Fitted by [Your Name], [Your Title]. Book online.

Title tag: Henry-Griffitts Club Fitting in [City] | [Facility]`,
  },
  {
    id: `B`,
    title: `B. Google Business Profile`,
    text: `Service to add: Golf club fitting — "Henry-Griffitts dynamic club fitting: lie angle read from your actual strike, shafts and heads tested in the bay, clubs built to your swing."

Description line to add: [Facility] is home to a Henry-Griffitts [Your Title]. Custom club fitting using the patented Henry-Griffitts lie-board method; clubs built in Coeur d'Alene, Idaho.

Post idea (no phone numbers or URLs in the text; use the button): "The right lie angle changes your starting direction more than any swing thought. Come see it on the lie board — book a Henry-Griffitts fitting." (Button: Book)`,
  },
  {
    id: `C`,
    title: `C. Social captions`,
    text: `Swap in your own photo of the bay, the board, or a happy customer (with permission).

Lie board. Toe-down, heel-down, or square — the mark on the tape tells the truth about where your irons are starting. That's the first thing we look at in a Henry-Griffitts fitting. Book yours. #HenryGriffitts #clubfitting #[City]golf

Equipment affects motion. If the club doesn't fit, you'll build a swing around it — and practice the compensation. Fix the club first. Henry-Griffitts fitting at [Facility].

Built, not bought. Six shaft flexes, three deflection points, three head designs, and lie, loft and length set to you. Every Henry-Griffitts set is built in Coeur d'Alene, Idaho, and ships in five business days.

Free for life. Loft and lie on a Henry-Griffitts set are checked and adjusted at no charge for as long as you own it. Bring yours in for a check — [booking link in bio].

Since 1983. Henry-Griffitts has fitted golfers one at a time for over forty years and taught the method to PGA professionals for more than thirty. I'm proud to be a Henry-Griffitts [Your Title]. Come see what a real fitting looks like.

Customer words (use only with written permission): "[Customer quote]." — [First name], fitted [month]. (Never turn a customer's stroke improvement into a statistic; quote them as themselves.)`,
  },
  {
    id: `D`,
    title: `D. Email to your own customer list`,
    text: `Subject: A fitting that reads your swing, not a chart

Hi [first name],

I fit golfers with the Henry-Griffitts system, and I want to explain in one paragraph why that matters.

Most fittings are static: a few measurements and a launch monitor. A Henry-Griffitts fitting is dynamic. You hit balls off the lie board, and the mark on the tape shows exactly how your club is arriving — which is why your irons start left, or right, before your swing has anything to do with it. We fix that first, then test shafts, lengths and lofts until the ball flight and your balance agree. Henry-Griffitts holds the patent on the method, has built clubs this way in Coeur d'Alene, Idaho since 1983, and checks and adjusts loft and lie on your set free for life.

If you've never had a fitting like that, [book a time here]. If you have Henry-Griffitts clubs already, come in for a complimentary loft and lie check.

[Your Name] Henry-Griffitts [Your Title], [Facility]`,
  },
  {
    id: `E`,
    title: `E. Print and signage lines`,
    text: `Bay sign: Henry-Griffitts Custom Club Fitting · [Your Name], [Your Title]
Counter card: "Ask about a Henry-Griffitts fitting — clubs built to your swing, not the average."
Business card line: Henry-Griffitts [Your Title]`,
  },
];

export const PUBLISH_CHECKLIST = [
  `Tree logo from HG files, clear space kept, linked to henry-griffitts.com`,
  `My title is the rung I hold, written in full`,
  `CTA is "book a fitting" with me; product detail links to HG`,
  `MSRP only; no wholesale, no margin`,
  `Founded 1983; patent 4,932,662; no stroke statistics; no Ol' Trusty loft numbers`,
  `No paid ads on the Henry-Griffitts name; no HG-named domains or handles`,
  `Adjustments described as arranged by me, done by HG`,
  `Photos are mine or from the HG kit; testimonials have permission`,
  `Sent to Henry-Griffitts for review; told HG when live for the link back`,
];

export const RULES_IN_ONE_BREATH = `Tree logo from HG files · your real title · book-the-fitting CTA · MSRP only · founded 1983 · patent 4,932,662 · no stroke statistics · no Ol' Trusty loft numbers · HG techs do the adjusting · real photos, permitted quotes · send it to Henry-Griffitts before it goes live.`;
